// extracted by mini-css-extract-plugin
export default {"root":"lh2cA6dBpr","title":"lhHbaKBhQm","description":"y4a7hLWBHv","timeIndication":"xSrI5CnL96"};